/** The Dashboard title: "Welcome back, <first name>", or the username when no name is set. */
export function dashboardGreeting(user: { firstName?: string | null; username?: string | null } | null | undefined): string {
  const name = user?.firstName?.trim() || user?.username?.trim()
  return name ? `Welcome back, ${name}` : 'Welcome back'
}
